export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          匿名投稿通道
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          安全匿名投稿，你的爆料将被严格保护。欢迎分享暗网相关见闻与吃瓜内容
        </p>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 border border-background-200/60 rounded-lg overflow-hidden">
            <div className="p-6 md:p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-full bg-accent-500/10 border border-accent-500/20 flex items-center justify-center">
                  <i className="ri-mail-send-line text-lg text-accent-400"></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-100">安全投稿表单</h3>
                  <p className="text-foreground-600 text-xs">我们不会记录你的任何个人信息</p>
                </div>
              </div>

              <form className="space-y-4">
                <div>
                  <label className="block text-foreground-400 text-xs font-medium mb-1.5">投稿标题</label>
                  <input
                    type="text"
                    name="title"
                    className="w-full px-4 py-2.5 bg-background-100 border border-background-200/60 rounded-md text-sm text-foreground-100 placeholder-foreground-600 focus:outline-none focus:border-primary-400/50 transition-colors"
                    placeholder="请输入投稿标题"
                  />
                </div>
                <div>
                  <label className="block text-foreground-400 text-xs font-medium mb-1.5">投稿内容</label>
                  <textarea
                    name="content"
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-2.5 bg-background-100 border border-background-200/60 rounded-md text-sm text-foreground-100 placeholder-foreground-600 focus:outline-none focus:border-primary-400/50 transition-colors resize-none"
                    placeholder="请描述你想分享的内容（最多500字）"
                  ></textarea>
                  <p className="text-foreground-600 text-xs mt-1">最多500字符</p>
                </div>

                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="form-honeypot"
                />

                <button
                  type="button"
                  className="w-full py-2.5 bg-accent-500 hover:bg-accent-600 text-background-50 font-medium text-sm rounded-md transition-all duration-200 whitespace-nowrap"
                >
                  匿名提交投稿
                </button>
              </form>
            </div>

            <div className="border-t border-background-200/60 px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
              <span className="text-foreground-500 text-xs">也可以通过以下方式联系我们</span>
              <div className="flex items-center gap-4">
                <span className="text-foreground-500 text-xs">
                  <i className="ri-mail-line mr-1"></i>tip@51darkweb.example.com
                </span>
                <span className="text-foreground-500 text-xs">
                  <i className="ri-message-2-line mr-1"></i>暗网站内私信
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}